import { render, staticRenderFns } from "./dishSales.vue?vue&type=template&id=f3ddd8a6&scoped=true&"
import script from "./dishSales.vue?vue&type=script&lang=js&"
export * from "./dishSales.vue?vue&type=script&lang=js&"
import style0 from "./dishSales.vue?vue&type=style&index=0&id=f3ddd8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ddd8a6",
  null
  
)

export default component.exports